import { render, staticRenderFns } from "./DropdownQuestion.vue?vue&type=template&id=d4fa4818&"
import script from "./DropdownQuestion.vue?vue&type=script&lang=ts&"
export * from "./DropdownQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports